/* ============================================================
   FX CO FOOTER
   flux-footer.js
============================================================ */

document.addEventListener("DOMContentLoaded", () => {

  const footer = document.querySelector(".flux-footer");

  if (!footer) return;

  /*=====================================
    Mouse Glow
  =====================================*/

  const glow = document.createElement("div");
  glow.className = "flux-mouse-glow";

  footer.appendChild(glow);

  let mouseX = 0;
  let mouseY = 0;

  let glowX = 0;
  let glowY = 0;

  footer.addEventListener("mousemove", (e) => {

    const rect = footer.getBoundingClientRect();

    mouseX = e.clientX - rect.left;
    mouseY = e.clientY - rect.top;

    glow.style.opacity = ".8";

  });

  footer.addEventListener("mouseleave", () => {

    glow.style.opacity = "0";

  });

  function animateGlow() {

    glowX += (mouseX - glowX) * 0.12;
    glowY += (mouseY - glowY) * 0.12;

    glow.style.left = glowX + "px";
    glow.style.top = glowY + "px";

    requestAnimationFrame(animateGlow);

  }

  animateGlow();

  /*=====================================
    Reveal
  =====================================*/

  const observer = new IntersectionObserver((entries) => {

    entries.forEach((entry) => {

      if (entry.isIntersecting) {

        footer.classList.add("flux-visible");

      }

    });

  }, {
    threshold: 0.2
  });

  observer.observe(footer);

  /*=====================================
    Diamond Tilt
  =====================================*/

  const diamond = document.querySelector(".flux-footer__diamond");

  if (diamond) {

    footer.addEventListener("mousemove", (e) => {

      const rect = footer.getBoundingClientRect();

      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;

      const rotateX = (0.5 - y) * 8;
      const rotateY = (x - 0.5) * 8;

      diamond.style.transform = `
        translateY(-4px)
        rotateX(${rotateX}deg)
        rotateY(${rotateY}deg)
      `;

    });

  }

  /*=====================================
    Logo Hover Polish
  =====================================*/

  const logo = document.querySelector(".flux-footer__logo");

  if (logo) {

    footer.addEventListener("mouseenter", () => {

      logo.style.transition = "transform .45s ease, filter .45s ease";

    });

  }

});